var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 284,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-743 -431)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.48972 145.49C4.48972 67.63 67.63 4.48972 145.49 4.48972 223.349 4.48972 286.49 67.63 286.49 145.49 286.49 223.349 223.349 286.49 145.49 286.49 67.63 286.49 4.48972 223.349 4.48972 145.49Z",
    fill: "#E5AA17",
    transform: "matrix(1.00355 0 0 1 738.494 427.51)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.49 55.6384 173.224 111.788 235.17 120.825 190.33 164.528 200.901 226.248 145.49 197.093 90.0217 226.248 100.649 164.528 55.8089 120.825 117.756 111.788Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00355 0 0 1 738.494 427.51)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesLogo);
export default __webpack_public_path__ + "static/media/FeaturesLogo.16865a86e1f064685a12650c98a3ef95.svg";
export { ForwardRef as ReactComponent };